import React from 'react';
import Show from '@uber/base-icons/show';
import DocumentOutlined from '@uber/icons/document-outlined';
import PencilLineOutlined from '@uber/icons/pencil-line-outlined';
import { useStyletron } from 'baseui';
import { Button, KIND, SIZE } from 'baseui/button';
import { type Atom, type WritableAtom, useAtom, useAtomValue } from 'jotai';
import { useOnceEffect } from '../../modernization-common/hooks/use-once-effect';
import { type TaskModeT, TASK_MODE } from '../task-state/constants';
import { useReviewDrawer } from './review-drawer';
type Props = {
  taskModeAtom: WritableAtom<TaskModeT, [(taskMode: TaskModeT) => TaskModeT], void>;
  readOnlyAtom: Atom<boolean>;
};
const buttonConfig = {
  size: SIZE.small,
  kind: KIND.tertiary
};
export const ReviewHeaderActions = ({
  taskModeAtom,
  readOnlyAtom
}: Props) => {
  const [_, theme] = useStyletron();
  const {
    openFeedbackPanel
  } = useReviewDrawer();
  const [taskMode, setTaskMode] = useAtom(taskModeAtom);
  const readOnly = useAtomValue(readOnlyAtom);
  useOnceEffect(() => {
    // default value of taskModeAtom is TASK_MODE.EDIT so for the first render, we need to set it to TASK_MODE.REVIEW
    setTaskMode(() => TASK_MODE.REVIEW);
  });
  return <>
      <Button {...buttonConfig} startEnhancer={taskMode !== TASK_MODE.EDIT ? <PencilLineOutlined height={theme.sizing.scale600} width={theme.sizing.scale600} /> : <Show height={theme.sizing.scale600} width={theme.sizing.scale600} />} onClick={() => setTaskMode(prev => prev === TASK_MODE.EDIT ? TASK_MODE.REVIEW : TASK_MODE.EDIT)} disabled={readOnly} overrides={readOnly ? {
      BaseButton: {
        style: {
          display: 'none'
        }
      }
    } : undefined}>
        {taskMode !== TASK_MODE.EDIT ? 'Edit Mode' : 'Review Mode'}
      </Button>
      <Button {...buttonConfig} startEnhancer={<DocumentOutlined height={theme.sizing.scale600} width={theme.sizing.scale600} />} onClick={openFeedbackPanel}>
        Feedback
      </Button>
    </>;
};